@if (transaction() !== undefined) {
  @if (invoiceDetail(); as invoice) {
    <odin-print-invoice [invoiceDetail]="invoice"></odin-print-invoice>
  } @else {
    <odin-print-receipt [receiptDetail]="createReceipt()"></odin-print-receipt>
  }
}

<div class="p-2 page-height overflow-auto bg-panel">
  @if (transaction !== undefined && !loading) {
    <div
      class="d-flex justify-content-between flex-column"
      style="max-height: 100%"
    >
      <div class="scrollable-container overflow-auto flex-space">
        <div
          class="d-flex justify-content-between align-items-center main-panel rounded-3 p-3"
        >
          <div
            class="d-flex align-items-center justify-content-start gap-2 w-100 flex-wrap"
          >
            <button
              class="bg-transparent border-0 d-flex align-items-center justify-content-center"
              (click)="BackButtonHandle()"
              data-test="tx-detail-back-button"
            >
              <mat-icon class="cursor-pointer my-0 text-dark"
                >chevron_left</mat-icon
              >
            </button>
            <h5 class="card-title m-0 flex-shrink-0">
              {{ transactionType }} Detail
            </h5>

            <div class="flex-fill"></div>

            <div
              class="d-flex align-items-center justify-content-end justify-content-md-end gap-2 flex-fill"
            >
              @if (canPrint()) {
                <button
                  mat-flat-button
                  data-test="Receipt-Options"
                  [matMenuTriggerFor]="receiptMenu"
                  class="bg-white-always mon-border-primary border mon-text-primary"
                >
                  Receipt <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>
                <mat-menu #receiptMenu="matMenu" xPosition="before">
                  <button mat-menu-item (click)="printReceipt()" data-test="Receipt-Print">
                    <mat-icon>receipt_long</mat-icon>
                    <span>Receipt</span>
                  </button>
                  <button mat-menu-item (click)="openInvoiceDialog()" data-test="Invoice-Print">
                    <mat-icon>request_quote</mat-icon>
                    <span>Invoice</span>
                  </button>
                </mat-menu>
              }

              @if (canReverse()) {
                <button
                  mat-flat-button
                  [disabled]="transaction() === null"
                  mat-flat-button
                  (click)="startReverseRequest()"
                  data-test="Reverse"
                  class="d-block bg-transparent mon-border-danger border mon-text-danger flex-shrink-0"
                >
                  Reverse
                </button>
              }

              @if (canRefund()) {
                <button
                  mat-flat-button
                  [disabled]="
                    transaction() === null || transaction().remainingValue === 0
                  "
                  (click)="startRefundRequest()"
                  data-test="Refund"
                  class="d-block bg-transparent mon-border-danger border mon-text-danger flex-shrink-0"
                >
                  Refund
                </button>
              }

              @if (canReCharge()) {
                <button
                  mat-flat-button
                  [disabled]="transaction() === null"
                  mat-flat-button
                  (click)="startRechargeRequest()"
                  data-test="Recharge"
                  class="d-block bg-transparent mon-border-warning border mon-text-warning flex-shrink-0"
                >
                  Recharge
                </button>
              }

              @if (canComplete()) {
                <button
                  mat-flat-button
                  [disabled]="transaction() === null"
                  mat-flat-button
                  (click)="startPreAuthCompleteRequest()"
                  data-test="Complete"
                  class="d-block mon-bg-success mon-border-success border mon-text-success flex-shrink-0"
                >
                  Complete Payment
                </button>
              }
            </div>
          </div>
        </div>

        <div class="w-100 main-panel rounded-3 mt-3 p-3 overflow-hidden">
          <div
            class="d-block d-sm-flex align-items-center justify-content-start gap-5"
          >
            <div
              class="d-flex align-items-center justify-content-start gap-1 flex-shrink-0 flex-grow-1"
            >
              <div class="me-2 d-flex align-items-center">
                <div
                  style="max-width: 50px"
                  class="w-100 border border-2 border-white rounded-3 overflow-hidden shadow-sm p-1"
                >
                  <fa-icon
                    class="transaction-icon d-block mx-auto w-100"
                    [matTooltip]="transactionIconTooltip(transaction())"
                    matTooltipPosition="right"
                    [icon]="transactionIcon(transaction())"
                    size="lg"
                  ></fa-icon>
                </div>
              </div>

              <div
                class="d-flex align-items-start jusfiy-content-between flex-column flex-fill flex-grow-1 flex-shrink-0"
              >
                <p class="my-0 fs-md-18 fs-mb-16">
                  <strong data-test="cardHolderName">{{
                    transaction().cardHolderDetails.name || 'No Name'
                  }}</strong>
                </p>
                <div
                  class="w-100 my-1"
                  style="height: 1px; background: #949494"
                ></div>
                <p class="my-0 fs-md-18 fs-mb-16">
                  <strong data-test="maskedCard">{{
                    transaction().maskedCard
                  }}</strong>
                </p>
              </div>
            </div>

            <div
              class="flex-shrink-0 flex-grow-1 mt-3 mt-sm-0 d-flex align-items-start jusfiy-content-between flex-column"
            >
              <p class="my-0 fs-md-18 fs-mb-16">
                <strong data-test="amount">{{
                  transaction().amount | currency: transaction().currencyCountry
                }}</strong>
                <span data-test="currency">
                  ({{ transaction().currencyCountry }})</span
                >
              </p>
              <div
                class="w-100 my-1"
                style="height: 1px; background: #949494"
              ></div>
              <p class="my-0 fs-md-18 fs-mb-16">
                <strong data-test="createdOn">{{
                  transaction().createdOn | date: 'dd/MM/yy HH:mm'
                }}</strong>
              </p>
            </div>
          </div>
        </div>

        <div class="mt-3">
          @if (timelineEvents.length > 0 && hasRelated()) {
            <div class="main-panel py-3 px-2 rounded-3">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <!-- Main Detail Column -->
                    <h5 class="fw-normal lh-1 mb-3">Timeline</h5>

                    <!-- Status - timeline -->
                    <div>
                      @for (event of timelineEvents; track event) {
                        <div
                          class="d-flex align-items-center justify-content-start mb-2"
                        >
                          <div
                            class="p-2 rounded-circle border border-1"
                            [ngClass]="{
                              'bg-transparent opacity-75': !event.isThis,
                              'bg-success': event.isThis && event.status,
                              'bg-danger': event.isThis && !event.status,
                              'border-success': event.status,
                              'border-danger': !event.status,
                            }"
                            role="status"
                          >
                            <span class="visually-hidden">Loading...</span>
                          </div>

                          <span
                            class="mb-0 ms-2"
                            [ngClass]="{ 'fw-bolder': event.isThis }"
                          >
                            {{ event.title }}
                            <span>{{
                              event.time | date: 'dd/MM/yy HH:mm'
                            }}</span>
                          </span>
                        </div>
                      }
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <!-- Related transactions -->
                    <div>
                      <h5 class="fw-normal my-0 lh-1">Related Transactions</h5>
                      @if (
                        relatedTransactions() &&
                        relatedTransactions().length > 0
                      ) {
                        <p
                          class="text-muted text-start mx-auto fst-italic lh-1 mt-1 mb-3"
                        >
                          <span class="d-none d-md-inline">Click</span
                          ><span class="d-inline d-md-none">Tap</span> to view
                        </p>
                      }

                      <div
                        class="w-100 pe-2"
                        style="max-height: 210px; overflow-y: auto"
                      >
                        @if (
                          !relatedTransactions() ||
                          relatedTransactions().length === 0
                        ) {
                          <p
                            class="text-muted text-center mx-auto fst-italic mt-4"
                          >
                            No related transactions
                          </p>
                        }
                        @for (
                          related of relatedTransactions();
                          track related.crossReference;
                          let isLast = $last
                        ) {
                          <button
                            (click)="OpenRelation(related)"
                            [attr.data-test]="
                              'related[' + related.crossReference + ']'
                            "
                            class="btn d-flex align-items-center justify-content-start gap-3 rounded-3 mb-2 border shadow-sm text-dark border-2 p-2 w-100"
                            [ngClass]="{
                              'mon-border-success': isSuccess(related),
                              'mon-border-danger': !isSuccess(related),
                            }"
                          >
                            <div>
                              <fa-icon
                                class="transaction-icon d-block mx-auto w-100"
                                [matTooltip]="transactionIconTooltip(related)"
                                matTooltipPosition="right"
                                [icon]="transactionIcon(related)"
                                size="xl"
                              ></fa-icon>
                            </div>
                            <div class="flex-fill w-100">
                              <div
                                class="d-flex align-items-center justify-content-start gap-2 mb-1"
                              >
                                <small
                                  class="fs-6 my-0 lh-sm text-start text-dark"
                                >
                                  {{ GetTransactionType(related) }}
                                </small>
                                <small class="fs-6 my-0 lh-sm text-start">
                                  {{
                                    related.amount
                                      | currency: related.currencyCountry
                                  }}
                                </small>
                              </div>
                              <small class="d-block text-start mt-0 mb-1 lh-sm">
                                Created At:
                                {{ related.createdOn | date: 'dd/MM/yy HH:mm' }}
                              </small>
                              <small class="d-block text-start my-0 lh-sm">
                                ID: {{ related.crossReference }}
                              </small>
                            </div>
                          </button>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }

          @if (
            !shelper.isNullOrEmpty(transaction().paymentDetail) &&
            !shelper.isGuid(transaction().paymentDetail)
          ) {
            <div class="mt-3">
              <div class="main-panel py-3 px-2 rounded-3">
                <h5
                  class="my-0 mb-3 lh-1 d-flex align-items-center gap-2 text-muted text-uppercase fs-md-13 fw-bold"
                  style="letter-spacing: 1px"
                >
                  <mat-icon class="my-0 fs-md-18 h-auto w-auto">description</mat-icon>
                  Payment Detail
                </h5>
                @if (shelper.isJsonB64(transaction().paymentDetail)) {
                  <div>
                    <table
                      class="table table-striped"
                      style="table-layout: fixed"
                    >
                      <tbody>
                        <tr>
                          <th>RAW Value</th>
                          <td class="overflow-hidden">
                            {{ transaction().paymentDetail }}
                          </td>
                        </tr>
                        <tr>
                          <th>Parsed Values</th>
                          <th></th>
                        </tr>
                        @for (
                          lineItem of CustomJsonLines(
                            transaction().paymentDetail
                          );
                          track lineItem.key
                        ) {
                          <tr>
                            <td>{{ lineItem.key }}</td>
                            <td>
                              <strong>{{ lineItem.value }}</strong>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>

                    <details>
                      <summary class="py-2 px-3 rounded-3">
                        <h5
                          class="card-title my-0 d-flex align-items-center justify-content-start gap-2"
                        >
                          <mat-icon class="my-0">data_object</mat-icon>
                          Raw JSON
                        </h5>
                      </summary>
                      <div class="px-2 px-md-3 py-3 bg-light rounded-3">
                        <pre data-test="paymentDetail" class="my-0">{{
                          shelper.decodeJsonB64(transaction().paymentDetail)
                            | json
                        }}</pre>
                      </div>
                    </details>
                  </div>
                } @else {
                  <span
                    data-test="paymentDetail"
                    class="d-inline-block bg-light border rounded-3 px-3 py-2 fw-bold"
                    style="word-break: break-word"
                    >{{ transaction().paymentDetail }}</span
                  >
                }
              </div>
            </div>
          }

          @if (
            !shelper.isNullOrEmpty(transaction().paymentReference) &&
            !shelper.isGuid(transaction().paymentReference)
          ) {
            <div class="mt-3">
              <div class="main-panel py-3 px-2 rounded-3">
                <h5
                  class="my-0 mb-3 lh-1 d-flex align-items-center gap-2 text-muted text-uppercase fs-md-13 fw-bold"
                  style="letter-spacing: 1px"
                >
                  <mat-icon class="my-0 fs-md-18 h-auto w-auto">tag</mat-icon>
                  Payment Reference
                </h5>
                <span
                  data-test="paymentReference"
                  class="d-inline-block bg-light border rounded-3 px-3 py-2 fw-bold"
                  style="word-break: break-word"
                  >{{ transaction().paymentReference }}</span
                >
              </div>
            </div>
          }

          @if (featureHelper['extended-transactions'] && hasBasketData()) {
            <details class="mt-3 main-panel rounded-3" open>
              <summary class="py-2 px-3 rounded-3">
                <h5
                  class="card-title my-0 d-flex align-items-center justify-content-start gap-2"
                >
                  <mat-icon class="my-0">shopping_basket</mat-icon>
                  Basket Details
                  @if (basketItemCount() > 0) {
                    <span class="basket-count" data-test="basketItemCount">{{ basketItemCount() }} {{ basketItemCount() === 1 ? 'item' : 'items' }}</span>
                  }
                  <span class="flex-fill"></span>
                  <button
                    type="button"
                    class="btn btn-sm btn-link p-0 basket-copy"
                    title="Copy basket JSON"
                    aria-label="Copy basket JSON"
                    (click)="copyBasketJson($event)"
                  >
                    <mat-icon class="my-0">content_copy</mat-icon>
                  </button>
                </h5>
              </summary>

              <div class="basket-scroll">
                <table class="table table-striped basket-table">
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th class="num">Qty</th>
                      <th class="num">Unit price</th>
                      <th class="num">Tax</th>
                      <th class="num">Line total</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (lineItem of LineItems(); track lineItem) {
                      <tr>
                        <td>
                          <div class="basket-desc">{{ lineItem.description }}</div>
                          @if (lineItem.sku || lineItem.commodityCode) {
                            <div class="basket-meta">
                              @if (lineItem.sku) { <span>SKU {{ lineItem.sku }}</span> }
                              @if (lineItem.commodityCode) { <span>Commodity {{ lineItem.commodityCode }}</span> }
                            </div>
                          }
                          @if (lineItem.discountAmount) {
                            <div class="basket-meta">Includes discount of {{ lineItem.discountAmount | currency: transaction().currencyCountry }}</div>
                          }
                        </td>
                        <td class="num">{{ lineItem.quantity }}@if (lineItem.unitOfMeasure) { <span class="basket-meta"> {{ lineItem.unitOfMeasure }}</span> }</td>
                        <td class="num" [attr.data-test]="'itemValue'">{{ lineItem.unitPrice | currency: transaction().currencyCountry }}</td>
                        <td class="num">
                          @if (lineItem.taxAmount !== undefined && lineItem.taxAmount !== null) {
                            {{ lineItem.taxAmount | currency: transaction().currencyCountry }}
                            <div class="basket-meta">{{ taxLabel(lineItem.taxCode, lineItem.taxRate) }}</div>
                          } @else { <span class="basket-meta">&mdash;</span> }
                        </td>
                        <td class="num"><strong>{{ lineTotal(lineItem) | currency: transaction().currencyCountry }}</strong></td>
                      </tr>
                    }
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="4" class="basket-total-label">Subtotal</td>
                      <td class="num">{{ basketSubtotal() | currency: transaction().currencyCountry }}</td>
                    </tr>
                    @for (discount of DiscountLineItems(); track discount) {
                      <tr class="basket-discount">
                        <td colspan="4" class="basket-total-label">
                          Discount: {{ discount.description || discount.code }}
                          <span class="basket-meta">{{ discountLabel(discount) }}</span>
                        </td>
                        <td class="num" [attr.data-test]="'discountValue'">-{{ discount.amount | currency: transaction().currencyCountry }}</td>
                      </tr>
                    }
                    @if (BasketDelivery(); as delivery) {
                      <tr>
                        <td colspan="4" class="basket-total-label">
                          Delivery: {{ delivery.carrier }}
                          @if (delivery.taxAmount !== undefined && delivery.taxAmount !== null) {
                            <span class="basket-meta">includes {{ delivery.taxAmount | currency: transaction().currencyCountry }} {{ taxLabel(delivery.taxCode, delivery.taxRate) }}</span>
                          }
                        </td>
                        <td class="num" [attr.data-test]="'deliveryValue'">{{ delivery.amount | currency: transaction().currencyCountry }}</td>
                      </tr>
                    }
                    @for (tax of TaxLineItems(); track tax) {
                      <tr>
                        <td colspan="4" class="basket-total-label">
                          Tax: {{ tax.description || tax.code }}
                          <span class="basket-meta">{{ taxLabel(tax.code, tax.rate) }}</span>
                        </td>
                        <td class="num" [attr.data-test]="'taxValue'">{{ tax.amount | currency: transaction().currencyCountry }}</td>
                      </tr>
                    }
                    <tr class="basket-grand-total">
                      <td colspan="4" class="basket-total-label">
                        Total charged
                        <span class="basket-meta">{{ taxTypeLabel() }}</span>
                      </td>
                      <td class="num"><strong>{{ transaction().amount | currency: transaction().currencyCountry }}</strong></td>
                    </tr>
                  </tfoot>
                </table>

                <div class="basket-notes">
                  @if (basketDifference(); as diff) {
                    <div class="basket-note basket-note-warn" data-test="basketReconciliation">
                      <mat-icon>info</mat-icon>
                      <span>
                        Basket total {{ basketTotal() | currency: transaction().currencyCountry }} differs from the amount charged by
                        {{ diff | currency: transaction().currencyCountry }}. Small differences are usually tax rounding.
                      </span>
                    </div>
                  }
                  @if (taxSummary().length > 0) {
                    <div class="basket-note" data-test="basketTaxSummary">
                      <mat-icon>percent</mat-icon>
                      <span>
                        @for (line of taxSummary(); track line.label; let last = $last) {
                          <span>{{ line.label }}: {{ line.amount | currency: transaction().currencyCountry }}</span>@if (!last) { <span class="basket-meta"> &middot; </span> }
                        }
                      </span>
                    </div>
                  }
                </div>
              </div>

              <!-- Basket Invoice -->
              @if (BasketInvoice(); as invoice) {
                <div class="px-2 py-3">
                  <h5
                    class="card-title my-0 d-flex align-items-center justify-content-start gap-2"
                  >
                    <mat-icon class="my-0">receipt_long</mat-icon>
                    Invoice {{ invoice.invoiceNumber }}
                  </h5>

                  <table
                    class="table table-striped mt-2 rounded-3 overflow-hidden"
                    style="table-layout: fixed"
                  >
                    <tbody>
                      @if (invoice.orderNumber) {
                        <tr>
                          <td>Order number</td>
                          <td><strong [attr.data-test]="'inv_orderNum'">{{ invoice.orderNumber }}</strong></td>
                        </tr>
                      }
                      @if (invoice.addressee) {
                        <tr>
                          <td>Addressee</td>
                          <td><strong [attr.data-test]="'inv_addressee'">{{ invoice.addressee }}</strong></td>
                        </tr>
                      }
                      @if (invoice.customerTaxNumber || invoice.taxRegistrationNumber) {
                        <tr>
                          <td>Customer tax number</td>
                          <td><strong [attr.data-test]="'inv_taxRegistrationNumber'">{{ invoice.customerTaxNumber || invoice.taxRegistrationNumber }}</strong></td>
                        </tr>
                      }
                      @if (invoice.cardAcceptorTaxNumber) {
                        <tr>
                          <td>Merchant tax number</td>
                          <td><strong [attr.data-test]="'inv_cardAcceptorTaxNumber'">{{ invoice.cardAcceptorTaxNumber }}</strong></td>
                        </tr>
                      }
                      <tr>
                        <td>Tax status</td>
                        <td><strong [attr.data-test]="'inv_isTaxExempt'">{{ invoice.isTaxExempt ? 'Exempt' : 'Not exempt' }}</strong></td>
                      </tr>
                      @if (invoice.orderDate) {
                        <tr>
                          <td>Order date</td>
                          <td><strong [attr.data-test]="'inv_orderDate'">{{ invoice.orderDate | date: 'dd/MM/yyyy' }}</strong></td>
                        </tr>
                      }
                      @if (invoice.issueDate) {
                        <tr>
                          <td>Issue date</td>
                          <td><strong [attr.data-test]="'inv_issueDate'">{{ invoice.issueDate | date: 'dd/MM/yyyy' }}</strong></td>
                        </tr>
                      }
                      @if (invoice.dueDate) {
                        <tr>
                          <td>Due date</td>
                          <td><strong [attr.data-test]="'inv_dueDate'">{{ invoice.dueDate | date: 'dd/MM/yyyy' }}</strong></td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
            </details>
          }

          <details class="mt-3 main-panel rounded-3" open>
            <summary class="py-2 px-3 rounded-3">
              <h5 class="card-title my-0">Extra Details</h5>
            </summary>

            <table class="table table-striped" style="table-layout: fixed">
              <tbody>
                <tr>
                  <td>{{ transactionType }} ID</td>
                  <td>
                    <strong [attr.data-test]="'crossRef'">{{
                      transaction().crossReference
                    }}</strong>
                  </td>
                </tr>

                @if (!shelper.isNullOrEmpty(transaction().operatorId)) {
                  <tr>
                    <td>{{ transactionType }} Completed By</td>
                    <td>
                      <strong
                        [attr.data-test]="'operatorName'"
                        [attr.data-user-id]="transaction().operatorId"
                        >{{ transaction().operatorName }}</strong
                      >
                    </td>
                  </tr>
                }

                <tr>
                  <td>{{ transactionType }} Type</td>
                  <td>
                    <div
                      class="d-flex align-items-center justify-content-start h-100"
                    >
                      <div style="width: 24px">
                        <fa-icon
                          class="d-block mx-auto"
                          [icon]="transactionIcon(transaction())"
                          size="lg"
                        ></fa-icon>
                      </div>
                      <strong
                        class="ms-2"
                        [attr.data-test]="'formattedChannel'"
                        >{{ transaction().formattedChannel }}</strong
                      >
                    </div>
                  </td>
                </tr>

                <tr>
                  <td>Card Type</td>
                  <td>
                    <div
                      class="d-flex align-items-center justify-content-start h-100"
                    >
                      <div
                        class="d-flex align-items-center justify-content-center h-100"
                      >
                        <div
                          class="rounded px-2"
                          style="
                            height: 24px;
                            background-color: #fff;
                            color: black;
                          "
                        >
                          @if (transaction().cardIcon.iconType === 'ICON') {
                            <mat-icon class="h-100 d-block" style="width: 24px"
                              >{{ transaction().cardIcon.value }}
                            </mat-icon>
                          } @else {
                            <img
                              class="h-100 d-block"
                              style="width: 24px"
                              [src]="transaction().cardIcon.value"
                              alt="Card scheme logo"
                            />
                          }
                        </div>
                      </div>
                      <strong class="ms-2" [attr.data-test]="'cardType'">{{
                        transaction().cardType
                      }}</strong>
                    </div>
                  </td>
                </tr>

                @if (transaction().cardHolderDetails.name) {
                  <tr>
                    <td>Cardholder Name</td>
                    <td>
                      <div
                        class="d-flex align-items-center justify-content-start h-100"
                      >
                        <strong
                          class="ms-2"
                          [attr.data-test]="'cardHolderName'"
                          >{{ transaction().cardHolderDetails.name }}</strong
                        >
                      </div>
                    </td>
                  </tr>
                }

                @if (transaction().cardHolderDetails.address) {
                  <tr>
                    <td>Cardholder Address</td>
                    <td>
                      <div
                        class="d-flex align-items-center justify-content-start h-100"
                      >
                        <strong
                          class="ms-2"
                          [attr.data-test]="'cardHolderAddress'"
                          >{{ transaction().cardHolderDetails.address }}</strong
                        >
                      </div>
                    </td>
                  </tr>
                }

                @if (transaction().cardHolderDetails.postcode) {
                  <tr>
                    <td>Cardholder Postcode</td>
                    <td>
                      <div
                        class="d-flex align-items-center justify-content-start h-100"
                      >
                        <strong
                          class="ms-2"
                          [attr.data-test]="'cardHolderPostcode'"
                          >{{
                            transaction().cardHolderDetails.postcode
                          }}</strong
                        >
                      </div>
                    </td>
                  </tr>
                }

                @if (billingAddressLines().length) {
                  <tr>
                    <td>Billing Address</td>
                    <td>
                      <div
                        class="d-flex align-items-center justify-content-start h-100"
                      >
                        <strong class="ms-2" [attr.data-test]="'billingAddress'">
                          @for (line of billingAddressLines(); track $index; let last = $last) {
                            {{ line }}@if (!last) { <br /> }
                          }
                        </strong>
                      </div>
                    </td>
                  </tr>
                }

                @if (deliveryAddressLines().length) {
                  <tr>
                    <td>Delivery Address</td>
                    <td>
                      <div
                        class="d-flex align-items-center justify-content-start h-100"
                      >
                        <strong class="ms-2" [attr.data-test]="'deliveryAddress'">
                          @for (line of deliveryAddressLines(); track $index; let last = $last) {
                            {{ line }}@if (!last) { <br /> }
                          }
                        </strong>
                      </div>
                    </td>
                  </tr>
                }

                @if (transaction().cardHolderDetails.phoneNumber) {
                  <tr>
                    <td>Cardholder Phone Number</td>
                    <td>
                      <div
                        class="d-flex align-items-center justify-content-start h-100"
                      >
                        <strong
                          class="ms-2"
                          [attr.data-test]="'cardHolderPhone'"
                          >{{
                            transaction().cardHolderDetails.phoneNumber
                          }}</strong
                        >
                      </div>
                    </td>
                  </tr>
                }

                @if (transaction().cardHolderDetails.emailAddress) {
                  <tr>
                    <td>Cardholder Email</td>
                    <td>
                      <div
                        class="d-flex align-items-center justify-content-start h-100"
                      >
                        <strong
                          class="ms-2"
                          [attr.data-test]="'cardHolderEmail'"
                          >{{
                            transaction().cardHolderDetails.emailAddress
                          }}</strong
                        >
                      </div>
                    </td>
                  </tr>
                }

                @if (transaction().cardHolderDetails.iPv4Address) {
                  <tr>
                    <td>IP Address</td>
                    <td>
                      <div
                        class="d-flex align-items-center justify-content-start h-100"
                      >
                        <strong class="ms-2" [attr.data-test]="'iPv4Address'">{{
                          transaction().cardHolderDetails.iPv4Address
                        }}</strong>
                      </div>
                    </td>
                  </tr>
                }

                @if (transaction().expiryDate) {
                  <tr>
                    <td>Card Expiry</td>
                    <td>
                      <div
                        class="d-flex align-items-center justify-content-start h-100"
                      >
                        <strong class="ms-2" [attr.data-test]="'expiryDate'">{{
                          transaction().expiryDate
                        }}</strong>
                      </div>
                    </td>
                  </tr>
                }

                @if (
                  showRefundAmount() &&
                  transaction().transactionType !== 'refund'
                ) {
                  <tr>
                    <td>Amount Refunded</td>
                    <td>
                      <div
                        class="d-flex align-items-center justify-content-start h-100"
                      >
                        <mat-icon
                          [matTooltip]="
                            'Value of accepted refunds against this transaction.'
                          "
                          matTooltipPosition="right"
                          >info
                        </mat-icon>
                        <strong
                          class="ms-2"
                          [attr.data-test]="'amountRefunded'"
                          >{{
                            transaction().amountRefunded || 0
                              | currency: transaction().currencyCountry
                          }}</strong
                        >
                      </div>
                    </td>

                    <td>Remaining Value</td>
                    <td>
                      <strong [attr.data-test]="'remainingValue'">{{
                        transaction().remainingValue
                          | currency: transaction().currencyCountry
                      }}</strong>
                    </td>
                  </tr>
                }

                @if (
                  !shelper.isNullOrEmpty(transaction().paymentReference) &&
                  shelper.isGuid(transaction().paymentReference)
                ) {
                  <tr>
                    <td>Payment Reference</td>
                    <td data-test="paymentReference">
                      <strong>{{ transaction().paymentReference }}</strong>
                    </td>
                  </tr>
                }

                @if (!shelper.isNullOrEmpty(transaction().paymentDetail)) {
                  <tr>
                    <td>Payment Detail</td>
                    <td data-test="paymentDetail">
                      <strong>{{ transaction().paymentDetail }}</strong>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </details>

          <!-- Callbacks Section -->
          @if (canAccessWebhooks()) {
            <details class="mt-3 main-panel rounded-3" open>
              <summary class="py-2 px-3 rounded-3">
                <div
                  class="w-100 d-flex align-items-center justify-content-between me-1 me-md-2"
                >
                  <h5 class="card-title my-0">Callback Attempts</h5>

                  <div class="d-flex align-items-center gap-2">
                    @if (!callbacksLoading) {
                      <button
                        mat-icon-button
                        [disabled]="transaction() === null"
                        (click)="getCallbackDetails()"
                        data-test="Refresh-Callback"
                        class="refresh-btn"
                        aria-label="Refresh"
                      >
                        <mat-icon>refresh</mat-icon>
                      </button>
                    }

                    @if (callbacksLoading) {
                      <div
                        style="width: 48px; height: 48px"
                        class="d-flex align-items-center justify-content-center"
                      >
                        <div
                          class="spinner-grow spinner-grow-sm text-dark"
                          role="status"
                          style="width: 24px; height: 24px"
                        >
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    }

                    <button
                      mat-flat-button
                      [disabled]="
                        transaction() === null || callbackAttempts.length === 0
                      "
                      (click)="startResendCallback()"
                      data-test="Reverse"
                      class="d-block bg-transparent mon-border-danger border mon-text-danger flex-shrink-0"
                    >
                      Resend<span class="d-none d-md-inline"> Callback</span>
                    </button>
                  </div>
                </div>
              </summary>

              <table
                class="table table-striped"
                style="table-layout: fixed; word-break: break-word"
              >
                @if (callbackAttempts && callbackAttempts.length > 0) {
                  <thead>
                    <tr>
                      <th>Attempt ID</th>
                      <th>Duration (ms)</th>
                      <th>Status Code</th>
                      <th>Requested Date</th>
                      <th class="d-none d-sm-table-cell">Trigger Type</th>
                    </tr>
                  </thead>
                }
                <tbody>
                  <!-- Show rows if callbackAttempts exist -->
                  @for (attempt of callbackAttempts; track attempt.id) {
                    <tr
                      (click)="callbackDialogBox(attempt)"
                      style="cursor: pointer"
                    >
                      <td>{{ attempt.id }}</td>
                      <td>{{ attempt.responseDurationMs }}ms</td>
                      <td>
                        <strong
                          [ngClass]="{
                            'text-success':
                              attempt.responseStatusCode >= 200 &&
                              attempt.responseStatusCode < 300,
                            'text-danger':
                              attempt.responseStatusCode < 200 ||
                              attempt.responseStatusCode >= 300,
                          }"
                          >{{ attempt.responseStatusCode }}</strong
                        >
                      </td>
                      <td>
                        {{ attempt.timestamp | date: 'dd/MM/yy HH:mm:ss' }}
                      </td>
                      <td class="d-none d-sm-table-cell">
                        <span>{{ attempt.url }}</span>
                      </td>
                    </tr>
                  }

                  <!-- Show this row when there are no callbacks -->
                  @if (callbacksLoading) {
                    <tr>
                      <td colspan="5" class="text-center text-muted py-3">
                        Fetching callback details for this transaction.
                      </td>
                    </tr>
                  }

                  @if (
                    !callbacksLoading &&
                    callbackAttempts &&
                    callbackAttempts.length === 0
                  ) {
                    <tr>
                      <td colspan="5" class="text-center text-muted py-3">
                        No callback details found for this transaction.
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </details>
          }
        </div>
      </div>
    </div>
  } @else {
    <odin-loading-spinner [active]="true"></odin-loading-spinner>
  }
</div>